import React from 'react';
import { ListingCard, ListingCardProps } from './ListingCard';
interface ListingCarouselProps {
  listings: ListingCardProps[];
}
export function ListingCarousel({
  listings
}: ListingCarouselProps) {
  return <div className="relative" data-id="element-1750">
      {/* Scroll Track — native swipe carousel (swipe to browse) */}
      <div className="flex gap-3 overflow-x-auto pb-4 px-4 snap-x snap-mandatory no-scrollbar" data-id="element-1751">
        {listings.map(listing => <div key={listing.id} id={`listing-${listing.id}`} className="snap-start flex-shrink-0 w-[88%] max-w-[340px] rounded-2xl transition-all" data-id="element-1752">
            <ListingCard {...listing} data-id="element-1753" />
          </div>)}
      </div>
    </div>;
}